import { Column, Row } from '../../../../components/global/utils';

import { Button } from '../../../../components/global/button';
import { Link } from 'gatsby';
import { SubHeader } from '../../../../components/typography';
import { respondTo } from '../../../../utils/breakpoints';
import styled from 'styled-components';

export const DisabledTxt = styled.div``;
export const DisabledHeader = styled(Column)``;

export const GridImg = styled.div`
  border-radius: 1rem 1rem 0rem 0rem;
  width: 100%;
  min-height: 10.3125rem;
  background: ${(props) => `url(${props.bgImg}) no-repeat top center`};
  background-size: cover;
`;
export const IconRow = styled(Row)`
  > i {
    margin-right: 0.5rem;
  }
`;
export const GridContent = styled.div``;
export const GridInfo = styled.div``;
export const GridRow = styled(Row)`
  align-items: center;
  padding-top: 0.5rem;
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.uiBlue} !important;
  > img {
    height: 3.75rem;
    width: auto;
    border-radius: 250px;
    margin-right: 1rem;
  }

  @media only screen and (max-width: 350px) {
    flex-direction: column;
    gap: 12px;
  }
`;
export const GridItem = styled(Link)`
  box-sizing: border-box;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  border: 1px solid ${(props) => props.theme.colors.uiLightBlue};
  transition: all 200ms ease-in;
  outline: 3px solid transparent;

  ${GridImg} {
    max-width: 100%;
  }
  ${GridContent} {
    padding: 1.15rem;
  }
  ${SubHeader} {
    font-size: 1rem;
    line-height: 150%;
    color: ${(props) => props.theme.colors.uiBlack};
  }
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.uiDarkBlue};
    outline: 3px solid ${(props) => props.theme.colors.uiDarkBlue};
    background: rgba(78, 191, 238, 0.2);
  }
`;

export const WorkshopType = styled.div`
  position: absolute;
  max-width: auto;
  height: 2.5rem;
  display: flex;
  font-weight: 700;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  top: 1.25rem;
  left: 1rem;
  font-size: 14px;
  border-radius: 0.5rem;
  background-color: ${(props) => props.theme.colors.uiWhite};
  color: ${(props) => props.theme.colors.uiDarkBlue};
  ${respondTo.m`
    padding: 0.5rem 1.25rem;
    font-size: 16px;
  `}
`;
export const SeeMore = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.uiDarkBlue};
  cursor: pointer;
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 2rem;
  ${respondTo.m`
    font-size: 1rem;
    padding: 1.5rem;
  `}
  > * .hideonmobile {
    display: none;
    ${respondTo.m`
      display: block`}
  }
`;

export const NewsBox = styled.div`
  gap: 20px;
  ${respondTo.xs`
    display:flex;
    flex-direction:column;
    justify-items:space-between;
  `}
  ${respondTo.m`
    display:grid;
  `}
  &.news, &.articleNews {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    grid-auto-flow: row;
    padding: 0 1rem;
    ${GridItem} {
      width: 100%;
      min-height: 16rem;
      max-height: 290px;
      &:first-of-type {
        ${respondTo.xs`
        max-height:700px;
          ${SubHeader} {
            font-size: 1rem;
            word-wrap:break-word;
          }
        `}
        ${SubHeader} {
          font-size: 1rem;
        }
        padding-bottom: 400px;
        max-height: 600px;
        ${respondTo.m`
          padding-bottom: 0;
          width: 100%;
          min-height: 100%;
          max-height: 100%;
        `}
        grid-area: 1 / 1 / 3 / 3;
        ${GridImg} {
          min-height: 21.125rem;
        }
        ${SubHeader} {
          box-sizing: border-box;
          height: auto;
          margin-right: 1.25rem !important;
          font-size: 1.5rem;
          word-wrap: wrap;
        }
        ${GridContent} {
          padding: 1.25rem;
          > span {
            font-size: 1rem;
            > p {
              > img {
                height: 3.75rem;
                width: auto;
                border-radius: 250px;
                margin-right: 1rem;
              }
            }
          }
        }
      }

      @media only screen and (max-width: 350px) {
        max-height: 350px;
      }
    }
  }

  &.workshops {
    display: grid;
    gap: 20px;
    ${respondTo.s`
      grid-template-columns: 1fr;
    `}
    ${respondTo.m`
      grid-template-columns: 1fr 1fr;
    `}
    ${GridItem} {
      &.disabled {
        cursor: not-allowed;
        border-color: #dddddd;
        ${GridContent} {
          min-height: calc(100% - 17.5625rem);
          justify-content: space-between;
          ${DisabledHeader} {
            ${SubHeader} {
              color: #5fa5c5 !important;
              padding-bottom: 1rem;
            }
            ${DisabledTxt} {
              color: #0f5575 !important;
              font-family: 'Raleway';
              font-style: normal;
              font-weight: 600;
              font-size: 16px;
              line-height: 150%;
            }
          }
          ${Button} {
            cursor: not-allowed;
          }
        }
      }
      position: relative;
      ${GridImg} {
        height: 14.5625rem;
        background-position: center;
        background-size: cover;
      }
      ${GridContent} {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 1.5rem;
        ${Button} {
          margin-top: 1.5rem;
          width: 6.75rem;
          height: 1.5rem;
          display: flex;
          justify-content: space-between;
        }
        ${SubHeader} {
          font-size: 1.5rem;
          padding-right: 3rem;
        }
        span {
          height: 50px;
          p {
            font-size: 1rem;
            color: ${(props) => props.theme.colors.uiDarkBlue} !important;
            svg {
              color: ${(props) => props.theme.colors.uiDarkBlue} !important;
              margin-right: 0.625rem;
            }
          }
        }
      }
    }
  }

  &.interviews {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-flow: row;
    ${GridItem} {
      width: 100%;
      height: 7.375rem;
      flex-direction: row;
      &.authors {
        height: 8.75rem;
      }
      ${GridImg} {
        background-size: cover !important;
        min-width: 40%;
        max-width: 40%;
        min-height: 100%;
        border-radius: 1rem 0 0 1rem;
      }
      ${GridContent} {
        ${SubHeader} {
          padding-top: 0.5rem;
        }
        > .tags {
          display: none;
          > p {
            font-weight: 700;
            background-color: ${(props) => props.theme.colors.bg.secondary};
            color: ${(props) => props.theme.colors.uiDarkBlue};
            padding: 0.1875rem 0.75rem;
            border-radius: 8px;
          }
        }
        > * .authorItem {
          display: flex;
          color: #5fa5c5;
          padding-top: 0rem;
        }
      }
      &:first-of-type {
        height: 100%;
        grid-area: 1 / 1 / 5 / 4;
        flex-direction: column;
        ${GridImg} {
          min-width: 100%;
          min-height: 70%;
          ${respondTo.xs`
            height: 18.75rem;
          `}
        }
        ${GridContent} {
          padding: 1rem 2rem;
          ${SubHeader} {
            color: #080e14 !important;
            font-weight: 600 !important;
            font-size: 1.5rem;
            color: ${(props) => props.theme.colors.uiDarkBlue};
          }
          > * .authorItem {
            padding-top: 1rem;
            font-family: 'Montserrat';
            font-size: 1rem;
            font-weight: 800;
            line-height: 1;
            color: #0f5575;
          }
          > .tags {
            display: flex;
            ${respondTo.xs`
              flex-wrap:wrap;
            `}
          }
          > .author {
            display: none;
          }
        }
      }
    }
  }

  &.articles {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    ${respondTo.xs`
      display:flex;
      flex-direction:column;
    `}
    ${respondTo.m`
      display:grid;
    `}
  }

  &.medtech {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
`;
